/* eslint-disable react/no-array-index-key */
import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  overflow: hidden;

  & h2 {
    color: ${(props) => props.theme.color.greyAlt};
    font-weight: 600;
    margin-bottom: 0;
    /* The word has to keep filling the container without ever pushing past it. */
    font-size: clamp(3rem, 14vw, 250px);
    line-height: 0.75;
    white-space: nowrap;
  }

  @media (min-width: 992px) {
    /* The gaps around this block live on the neighbouring sections. */
    padding-block: 0;

    .cta-row {
      margin-top: 53px;
    }

    .grid {
      margin-top: -25px;
    }
  }

  @media (max-width: 991.98px) {
    padding-bottom: 3rem;

    .grid {
      margin-top: -0.5rem;
    }
  }
`

const Grid = styled.div`
  position: relative;
  z-index: 2;
`

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background-color: #e5e5e5;
  color: ${(props) => props.theme.color.text.main};

  /* Notched bottom-right corner */
  &::after {
    position: absolute;
    content: '';
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-top: 45px solid transparent;
    border-right: 45px solid #fff;
    z-index: 2;
  }

  @media (min-width: 992px) {
    min-height: 214px;
    padding: 31px 1rem 25px;
  }

  @media (max-width: 991.98px) {
    min-height: 150px;
    padding: 1rem;

    &::after {
      border-top-width: 30px;
      border-right-width: 30px;
    }
  }
`

const Icon = styled.img`
  width: auto;

  @media (min-width: 992px) {
    height: 90px;
    margin-bottom: 11px;
  }

  @media (max-width: 991.98px) {
    height: 45px;
    margin-bottom: 0.75rem;
  }
`

const Title = styled.div`
  text-align: center;

  & p {
    font-weight: 600;
    line-height: 25px;
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    & p {
      font-size: 16px;
      font-weight: 700;
    }
  }

  @media (max-width: 991.98px) {
    & p {
      font-size: 15px;
      line-height: 20px;
    }
  }
`

const Description = styled.div`
  font-family: ${(props) => props.theme.font.family.main};
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  color: #292929;

  & p {
    text-align: justify;
    word-break: break-word;
    margin-bottom: 0;
  }
`

function ServicesInlineLanding({ services }) {
  return (
    <Section>
      <div className="container">
        <h2>{services.title}</h2>

        <div className="row">
          <div className="col-lg-11 ml-lg-auto">
            <Grid className="grid row">
              {services.items &&
                services.items.map((edge, index) => (
                  <div className="col-6 col-lg-3 mb-4" key={index}>
                    <Card>
                      {edge.icon && edge.icon.localFile && (
                        <Icon src={edge.icon.localFile.publicURL} alt="" />
                      )}
                      {edge.link && edge.link.title && (
                        <Title>
                          <ParseContent content={edge.link.title} />
                        </Title>
                      )}
                    </Card>
                  </div>
                ))}
            </Grid>

            {services.cta && services.cta.description && (
              <div className="row cta-row mt-3">
                <div className="col-lg-7">
                  <Description>
                    <ParseContent content={services.cta.description} />
                  </Description>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ServicesInlineLanding
